module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team/teachers/rafal-fbe17dbaf3f92f0d1a533682ab17b502.webp";